

/**
* directives.carousel Module
*
* Description
*/
var app = angular.module('directives.localization', []);

	require('./stylesheet/localization.style.scss');
	require('./directives/localization.directive.js');

module.exports = app;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/localization/index.js
 ** module id = 171
 ** module chunks = 1
 **/